// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1A3ct","info":"PatientInfo_info__2iPrl"};